/**
 * 共享页脚组件 - 包含双备案信息
 *
 * 功能：
 * - 显示ICP备案信息（保留现有）
 * - 显示公安备案信息（带官方图标）
 * - 支持完整版和简洁版两种显示模式
 * - 响应式设计，适配移动端和桌面端
 */

import React from 'react';

export default function Footer({
  variant = "full",           // "full" | "simple"
  className = "",             // 自定义样式
  showCopyright = true,       // 是否显示版权信息
  showFiling = true           // 是否显示备案信息
}) {

  if (variant === "simple") {
    // 简洁版：单行显示两个备案信息
    return (
      <footer className={`bg-gray-50 border-t border-gray-200 py-3 ${className}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-xs text-gray-600 space-y-1">
            {/* 备案信息 - 简洁版 */}
            {showFiling && (
              <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                {/* ICP备案 */}
                <a
                  href="https://beian.miit.gov.cn"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-blue-600 transition-colors"
                >
                  <span className="text-gray-400 mr-1">🏛️</span>
                  鄂ICP备2025103164号-2
                </a>

                {/* 分隔符 */}
                <span className="hidden sm:inline text-gray-300">|</span>

                {/* 公安备案 */}
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=42010402001671"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-blue-600 transition-colors flex items-center gap-1"
                >
                  <img
                    src="/gonganbeian.png"
                    alt="公安备案"
                    className="inline h-4 w-4"
                    title="鄂公网安备42010402001671号"
                  />
                  鄂公网安备42010402001671号
                </a>
              </div>
            )}
          </div>
        </div>
      </footer>
    );
  }

  // 完整版：多行显示，含版权信息
  return (
    <footer className={`bg-gray-50 border-t border-gray-200 py-6 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-gray-600 space-y-3">

          {/* 版权信息 */}
          {showCopyright && (
            <div className="text-gray-500 text-xs">
              © 2020-2026 旅报报 · 美国签证助手
            </div>
          )}

          {/* 备案信息 */}
          {showFiling && (
            <>
              {/* ICP备案 */}
              <div>
                <a
                  href="https://beian.miit.gov.cn"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-blue-600 transition-colors inline-flex items-center gap-1"
                >
                  <span className="text-gray-400">🏛️</span>
                  <span>鄂ICP备2025103164号-2</span>
                </a>
              </div>

              {/* 公安备案 */}
              <div>
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=42010402001671"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-blue-600 transition-colors inline-flex items-center gap-2"
                >
                  <img
                    src="/gonganbeian.png"
                    alt="公安备案"
                    className="h-5 w-5"
                    title="鄂公网安备42010402001671号"
                  />
                  <span>鄂公网安备42010402001671号</span>
                </a>
              </div>
            </>
          )}

          {/* 底部空间 */}
          <div className="text-xs text-gray-400 pt-2">
            建议使用Chrome、Firefox或Safari浏览器获得最佳体验
          </div>
        </div>
      </div>
    </footer>
  );
}
